import React, { ReactNode } from "react";
import classNames from 'classnames'
// import './style.scss'

interface StickyContainerProps {
    /** children components to be rendered within the Container layout */
    children?: ReactNode,
    position?: string,
    top?: string,
    // right?: string,
    bottom?: string,
    // left?: string,
    padding?: string,
    margin?: string,
    hide?: boolean  // Hide StickyContainer
}



export function StickyContainer(props: StickyContainerProps){
    const {position = "top-left", top = "top-4", bottom = "bottom-4", padding="", margin="", hide = false, children} = props;

    return (
        <>
            {!hide && <div className={classNames(
                `w-full h-full`, 
                `flex flex-col`, 
                `relative`,
                {
                    'justify-start items-start': position === 'top-left',
                    'justify-end items-start': position === 'bottom-left',
                    'justify-start items-end': position === 'top-right',
                    'justify-end items-end': position === 'bottom-right'
                }
            )}>
                <div className={classNames(
                    `sticky`,
                    `bg-sticky-container-bg sticky-container-wrapper`,
                    `w-full`,
                    `max-w-fit`,
                    `h-fit`,
                    `sm:px-4 px-2 sm:py-4 md:pt-stickyContainerTop pb-5`,
                    // {
                        position === 'top-left' ? `${top}` : '',
                        position === 'bottom-left' ? `${bottom}` : '',
                        position === 'top-right' ? `${top} ml-auto` : '',
                        position === 'bottom-right' ? `${bottom} ml-auto` : ''
                    // }
                )}
                style={{
                    padding: padding,
                    margin: margin
                }}
                >
                    {children}
                </div>
            </div>}
        </>
    )
}